export default __webpack_public_path__ + "static/media/copy-grey.80e4506e.svg";